class CollectionSort extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.form = this.querySelector("form");
    this.sortButtons = this.querySelectorAll("[data-sort] button");
    this.sortInput = this.querySelector("[data-sort-input]");
    this.collectionContainer = this.closest("#product-grid-section");
    this.toggleFilterButton = this.querySelector("[data-toggle-filter]");
    this.targets = document.querySelectorAll("[data-sort-target]");
    this.gridSection = document.querySelector("#product-grid-section");
    this.rootMarginValue = "0px";
  }

  connectedCallback() {
    const filter = document.querySelector('.main-collection__controls');
    const sentinel = document.querySelector('[data-sort-target="stick"]');
    const header = document.querySelector('.header');

    // ===== Sticky Filter Bar Logic =====
    if (filter && sentinel && header) {
      const updateStickyTop = () => {
        const isMobile = window.innerWidth < 960;
        const headerHeight = header.offsetHeight - (isMobile ? 8 : 25);
        filter.style.setProperty('--sticky-top', `${headerHeight}px`);
        return headerHeight;
      };

      let headerHeight = updateStickyTop();

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (!entry.isIntersecting) {
            headerHeight = updateStickyTop();
            document.body.classList.add('sort--sticking');
            filter.classList.add('clp__filter--sticky');
          } else {
            document.body.classList.remove('sort--sticking');
            filter.classList.remove('clp__filter--sticky');
          }
        },
        {
          rootMargin: `-${headerHeight}px 0px 0px 0px`,
          threshold: 0,
        }
      );

      observer.observe(sentinel);

      window.addEventListener('resize', () => {
        headerHeight = updateStickyTop();
      });
    }

    this.sortButtons.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        this.sortInput.value = e.target.dataset.value;
        this.handleSort();
      });
    });

    this.toggleFilterButton.addEventListener("click", (e) => {
      e.preventDefault();
      const event = new CustomEvent("mobile-filter:open", { bubbles: true });
      this.dispatchEvent(event);
    });
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData);
  }

  handleSort() {
    const searchParams = this.createSearchParams(this.form);
    this.submitForm(searchParams);
  }

  submitForm(searchParams) {
    const url = new URL(window.location.href);
    searchParams.forEach((value, key) => {
      url.searchParams.set(key, value);
    });

    history.replaceState("", "", url);
    this.fetchCollection(url.href);
  }

  fetchCollection(url) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        const parsedHTML = new DOMParser().parseFromString(html, "text/html");
        const newContainer = parsedHTML.querySelector("#product-grid-section");
        this.collectionContainer.innerHTML = newContainer.innerHTML;

        document.dispatchEvent(new CustomEvent("collection:updated"));
      });
  }
}

if (!customElements.get("collection-sort")) {
  customElements.define("collection-sort", CollectionSort);
}
